<div class="password-requirements_container is-active">
    <p>Password Requirements:</p>
    <ul *ngIf="validationList && validationList.length > 0">
        <li *ngFor="let validation of validationList"><mat-icon class="icon icon--check_circle_outline" *ngIf="checkExpression(validation); else crossBlock">check_circle_outline</mat-icon><ng-template #crossBlock><mat-icon class="icon icon--block">block</mat-icon></ng-template>{{validation.message}}</li>
    </ul>
</div>
